(function() {
    'use strict';

    angular.module("settings")
        .controller('MessagesListController', MessagesListController);

    MessagesListController.$inject = ['datatableDefaultPageSizeValueConst', 'contactDataService', 'contactSrvc', 'searchFilterSrvc', 'notificationSrvc', 'lodashService', 'messagesMessagesConst', 'variableSrvc', '$state', 'checkSearchSrvc', 'userStorageSrvc', 'clientcontactPermissionsConst', 'crmCaseStatusConst', 'filterQuerySrvc'];

    function MessagesListController(datatableDefaultPageSizeValueConst, contactDataService, contactSrvc, searchFilterSrvc, notificationSrvc, lodashService, messagesMessagesConst, variableSrvc, $state, checkSearchSrvc, userStorageSrvc, clientcontactPermissionsConst, crmCaseStatusConst, filterQuerySrvc) {
        var self = this;

        self.loading = true;

        self.pageOpts = {
            count: undefined,
            page: 1,
            pageSize: datatableDefaultPageSizeValueConst
        };

        self.messagesRows = [];
        self.messagesCols = [{
            title: 'Nr sprawy',
            value: 'pk',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'E-mail',
            value: 'client_email',
            type: 'link',
            linkTo: 'layout.client.details',
            linkParamProp: 'client_pk',
            orderValue: 'client__user__email',
            searchable: true,
            orderable: true
        }, {
            title: 'Klient',
            value: 'client_name',
            type: 'text',
            orderValue: 'client__user__first_name',
            searchable: true,
            orderable: true
        }, {
            title: 'Rodzaj sprawy',
            value: 'competency',
            orderValue: 'competency__name',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'Nr zamówienia',
            value: 'order',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'Osoba odpowiedzialna',
            value: 'responsible_person_name',
            type: 'text',
            orderValue: 'responsible_person__user__first_name',
            searchable: true,
            orderable: true
        }, {
            title: 'Status',
            value: 'status_display',
            type: 'text'
        }];
        self.modelPermissions = clientcontactPermissionsConst;

        self.logsInfo = [{
            title: 'Data dodania',
            value: 'date_added'
        }, {
            title: 'Data modyfikacji',
            value: 'date_modified'
        }, {
            title: 'Edytowano przez',
            value: 'last_modified_by'
        }];

        self.exposingData = {
            color: {true: '#f8ac59'},
            conditionProp: 'is_last_message_from_client',
            conditionValue: true
        };

        self.filterData = {
            status: [
                crmCaseStatusConst.new.value,
                crmCaseStatusConst.open.value
            ]
        };

        self.caseStatusFilter = Object.keys(crmCaseStatusConst).map(function(key) {
            return crmCaseStatusConst[key];
        });

        self.searchQuery = {
            pk: null,
            client_email: null,
            client_name: null,
            competency: null,
            responsible_person_name: null,
            order: null,
            ordering: null
        };

        self.questionFilter = null;

        self.onCreate = onCreate;
        self.onEdit = onEdit;
        self.onDelete = onDelete;

        self.onPageChange = onPageChange;
        self.onSearchQueryChange = onSearchQueryChange;
        self.onFilter = onFilter;

        self.filterAllQuestions = filterAllQuestions;
        self.filterMyQuestions = filterMyQuestions;

        activate();

        function activate() {
            self.filterData = filterQuerySrvc.initializeFilterData(self.filterData);
            self.pageOpts = filterQuerySrvc.initializePageOpts(self.pageOpts);
            self.searchQuery = filterQuerySrvc.initializeSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            getContacts();
        }

        function getContacts(filterObj) {
            self.loading = true;

            if (!filterObj) {
                filterObj = {
                    page: self.pageOpts.page,
                    page_size: self.pageOpts.pageSize,
                    responsible_person: $state.params.responsible_person,
                    pk: self.searchQuery.pk,
                    client_email: self.searchQuery.client_email,
                    client_name: self.searchQuery.client_name,
                    competency: self.searchQuery.competency,
                    responsible_person_name: self.searchQuery.responsible_person_name,
                    order: self.searchQuery.order,
                    ordering: self.searchQuery.ordering,

                    status: self.filterData.status
                };
            }
            return contactDataService.list(filterObj)
                .$promise
                .then(
                    function(response) {
                        self.messagesRows = response.results;
                        self.pageOpts.count = response.count;
                        return response;
                    },
                    function(response) {
                        if (response.status === 404 && filterObj.page !== 1) {
                            checkSearchSrvc.recall(filterObj, getContacts);
                        }
                    }
                ).finally(
                    function(response) {
                        self.loading = false;
                        return response;
                    }
                );
        }

        function onCreate() {
            $state.go('layout.messages.create');
        }

        function onEdit(row) {
            $state.go('layout.messages.update', { pk: row.pk });
        }

        function onDelete(row) {
            return contactSrvc.remove(row.competency, row.pk, function(response) {
                notificationSrvc.notification("success", messagesMessagesConst.delete);
                lodashService.remove(self.messagesRows, { pk: row.pk });
                return response;
            }, function(error) {
                notificationSrvc.notification("error", error.data.detail);
            });
        }

        function onPageChange() {
            filterQuerySrvc.updatePageOpts(self.pageOpts);
            filterQuerySrvc.setLocationParams();
            return getContacts();
        }

        function onSearchQueryChange() {
            filterQuerySrvc.updateSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            return getContacts();
        }

        function onFilter() {
            filterQuerySrvc.updateFilterData(self.filterData);
            filterQuerySrvc.setLocationParams();
            return getContacts();
        }

        function filterMyQuestions() {
            $state.go('layout.messages.list', { responsible_person: userStorageSrvc.getUser().username });
        }

        function filterAllQuestions() {
            $state.go('layout.messages.list', { responsible_person: undefined });
        }
    }
})();
